import React, { useEffect, useState } from "react";
import { applyDiscountRules, isOutOfStock } from "../../helpers/common";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./Card.scss";
import { ReactComponent as UAEDirham } from "../../SVGs/UAEDirham.svg";
import { useTranslation } from "react-i18next";

const Card = ({
  product, 
  areDiscountRulesApplied = false,
  isSlider = true,
  isCategory = false,
}) => {
  const [newProduct, setNewProduct] = useState(null);
  const [outOfStock, setOutOfStock] = useState(false);
  const discountRules = useSelector((state) => state.discountRules);

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const getProductTitle = (prod) => {
    if (!prod?.attributes) return "";
    let prodName = prod.attributes.Title;
    if (currentLanguage !== "en") {
      const localization = prod.attributes.localizations?.data?.find(
        (locale) => locale?.attributes?.locale === currentLanguage
      );
      if (localization) {
        prodName = localization.attributes.Title;
      }
    }
    return prodName;
  };

  useEffect(() => {
    if (!product) return;

    if (!areDiscountRulesApplied) {
      const discountedProduct = applyDiscountRules([structuredClone(product)], discountRules);
      setNewProduct(discountedProduct[0]);
      setOutOfStock(isOutOfStock(discountedProduct[0]?.attributes?.Variants));
    } else {
      setNewProduct(product);
      setOutOfStock(isOutOfStock(product?.attributes?.Variants));
    }
  }, [product, discountRules, areDiscountRulesApplied]); 

  if (!newProduct?.attributes) return null;

  return (
    <Link
      className="card"
      to={`/product/${newProduct.attributes.SEOURL || ""}`}
      key={newProduct.id}
    >
      <div className="image">
        {outOfStock && (
          <p className="out-of-stock-banner">{t("product.out-of-stock")}</p>
        )}
        <img
          className={["img", isCategory ? "category-card" : "", outOfStock ? "out-of-stock" : ""].join(" ")}
          src={`${process.env.REACT_APP_IMAGE_URL}${newProduct.attributes.DefaultImage?.data?.attributes?.url || ""}`}
          alt={newProduct.attributes.DefaultImage?.data?.attributes?.alternativeText || "product"}
        />
      </div>
      <div className="info">
        <h1 className="name">{getProductTitle(newProduct)}</h1>
        <div className="price">
          {newProduct.attributes.discountedPrice &&
          newProduct.attributes.discountedPrice !== newProduct.attributes.Price ? (
            <div className="real-price">
              <div className="container">
                <span className="currency"><UAEDirham /></span>
                <span className="numerical-price">{newProduct.attributes.Price}</span>
              </div>
              {!isSlider && <span className="vat">{t("home.price-with-vat")}</span>}
            </div>
          ) : null}
          <div className="discounted-price">
            <div className="container">
              <span className="currency"><UAEDirham /></span>
              <span className="numerical-price">
                {newProduct.attributes.discountedPrice ?? newProduct.attributes.Price}
              </span>
            </div>
            {!isSlider && <span className="vat">{t("home.price-with-vat")}</span>}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card;